// extracted by mini-css-extract-plugin
export default {"backdrop":"Style_backdrop__AQtn2"};